import { usePage } from "@inertiajs/react"
import type { ReactNode } from "react"
import { useEffect } from "react"
import { toast } from "sonner"

import { Toaster } from "@/components/ui/sonner"
import type { FlashData } from "@/types"

function useFlash() {
  const { flash } = usePage()

  useEffect(() => {
    // setTimeout + cleanup prevents double-firing in React StrictMode
    const showFlash = (f: FlashData) => {
      if (f.alert) toast.error(f.alert)
      if (f.notice) toast(f.notice)
    }
    const timeout = setTimeout(() => showFlash(flash), 0)
    return () => clearTimeout(timeout)
  }, [flash])
}

interface PersistentLayoutProps {
  children: ReactNode
}

export default function PersistentLayout({ children }: PersistentLayoutProps) {
  useFlash()
  return (
    <>
      {children}
      <Toaster richColors />
    </>
  )
}
